import {
  ChannelSettingDropdown,
  type OverrideValue,
} from './ChannelSettingDropdown';

export function ChannelBotMessagesSection({
  value,
  onValueChange,
  globalEnabled,
  isReadOnly = false,
}: {
  value: OverrideValue;
  onValueChange: (value: OverrideValue) => void;
  globalEnabled: boolean;
  isReadOnly?: boolean;
}) {
  return (
    <ChannelSettingDropdown
      title="Respond to Bot Messages"
      description="Override the team-wide setting for responding to bot messages in this channel"
      value={value}
      onValueChange={onValueChange}
      globalEnabled={globalEnabled}
      isReadOnly={isReadOnly}
    />
  );
}
